module.exports = __webpack_public_path__ + "static/media/bern.6e94eac0.png";